import { render, staticRenderFns } from "./download-file.vue?vue&type=template&id=036b5c41&scoped=true"
import script from "./download-file.vue?vue&type=script&lang=js"
export * from "./download-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b5c41",
  null
  
)

export default component.exports